import { Pipe, PipeTransform } from '@angular/core';
import { DynamicTranslationService } from './dynamic-translation.service';

@Pipe({
  name: 'lsTranslate'
})
export class TranslatePipe implements PipeTransform {
  constructor(private translation: DynamicTranslationService) {}

  public transform(value: string): any {
    return this.translation.translate(value);
  }
}
